/* eslint-disable react/prop-types */
import DatePicker from 'shared/components/date-picker';
import * as S from './styles';
import {Popover} from '@mantine/core';
import {DateFilterProps} from 'shared/migration-components/filter-list/types';
import dateFnsService from 'shared/services/date-fns-service';
import Calendar from 'shared/components/calendar';

interface Props {
  handleConfirm: (dateFilter: DateFilterProps[]) => void;
  value?: DateFilterProps[];
  opened: boolean;
  setOpened: (opened: boolean) => void;
  dateInterval?: boolean;
}

const DateFilter: React.FC<Props> = ({
  value = [],
  opened,
  setOpened,
  handleConfirm,
  dateInterval = false,
}) => {
  const dateToDateFilter = (date: Date, isStart = true): DateFilterProps => ({
    date: dateFnsService.apiDateFormat(date),
    time: isStart ? '00:00' : '23:59:59',
  });

  const onChange = (startDate: Date, endDate?: Date) => {
    const startDateFilter = dateToDateFilter(startDate);
    const endDateFilter = dateToDateFilter(endDate ?? startDate, false);

    handleConfirm([startDateFilter, endDateFilter]);
  };

  const getLabel = () => {
    const [startDateFilter, endDateFilter] = value;

    if (!startDateFilter && !endDateFilter) return '';

    const startDate = new Date(
      `${startDateFilter.date}T${startDateFilter.time}`,
    );

    const endDate = new Date(`${endDateFilter.date}T${endDateFilter.time}`);

    if (dateInterval)
      return `${dateFnsService.dateFormat(
        startDate,
      )} até ${dateFnsService.dateFormat(endDate)}`;

    return dateFnsService.dateFormat(startDate);
  };

  return (
    <Popover
      opened={opened}
      onClose={() => setOpened(false)}
      zIndex={1001}
      position="bottom-start"
      styles={{
        dropdown: {padding: 0, borderRadius: 6},
      }}>
      <Popover.Target>
        <S.InputDateValue onClick={() => setOpened(true)}>
          <span>{getLabel()}</span>
        </S.InputDateValue>
      </Popover.Target>
      <Popover.Dropdown>
        <S.Container>
          {!dateInterval && <DatePicker confirm={onChange} />}
          {dateInterval && <Calendar confirm={onChange} />}
        </S.Container>
      </Popover.Dropdown>
    </Popover>
  );
};

export default DateFilter;
